<template>
    <div>

        <!-- credit cards -->
        <tq-credit-card @click.native="m_clickCreditCard_f(creditCard_c)"
                        v-for="(creditCard_c, index_n) in p_uds_creditCards_byId_c"
                        :key="index_n"
                        :p_current-user-data_c="p_currentUserData_c"
                        :p_main-credit-card_b="co_mainCreditCard_c && co_mainCreditCard_c.udscc_m_id_s() === creditCard_c.udscc_m_id_s()"
                        :p_system_lang-code_e="store_system_langCode_ve.val"
                        :p_credit-card_c="creditCard_c"
                        :p_show-drop-down_b="p_showDropDown_b"
                        :pe_delete-credit-card_f="m_removeCreditCard_f"
                        :class="pe_clickCreditCard_f && 'TQ_clickable TQ_bg_hover_goldLite'"/>

        <!-- btn - add credit card -->
        <div class="TQ_border TQ_inline TQ_borderRadius TQ_box_shadow2 TQ_margin_8px TQ_padding_32px_0px TQ_verticalAlignMiddle TQ_clickable TQ_bg_hover_goldLite TQ_borderBox TQ_width_200px"
             @click="m_addCreditCard_f">
            <div class="TQ_padding_16px_0px">
                + {{ ass_strings.threeWords_newCreditCard[store_system_langCode_ve.val] }}
            </div>
        </div>

        <!-- popup - add credit card-->
        <tq-popup :show="showPopup_vb" max-width="500px" padding="0px" :show-close-btn="true">
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px TQ_margin_bottom_8px">
                {{ ass_strings.threeWords_newCreditCard[store_system_langCode_ve.val] }}
            </div>

            <div class="TQ_padding_0px_16px TQ_textAlign_justify TQ_text_capitalize_first_letter">
                *{{ ass_strings.sentence_addCreditCardWarning[store_system_langCode_ve.val]}}.
            </div>

            <tq-loader-container :p_tq-loader_b="true" :p_show-loader_b="!icreditUrl_s">
                <iframe v-if="icreditUrl_s" :src="icreditUrl_s" width="100%"
                        height="570px"
                        frameBorder="0"
                        class="TQ_bg_white">

                </iframe>
            </tq-loader-container>

        </tq-popup>

    </div>
</template>

<script>
import {store_getStateValue_vo, store_var} from "@/store";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {
    server_getPaymentLandingPage_token_f,
} from "@/scripts/Server/S_ServerPre";
import TqPopup from "@/components/basic/TqPopup";
import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
import {enum_costCurrency_n, enum_iframeMsg, enum_eventsListenersNames} from "../../../functions/src/shareCode/Share_S_Enum";
import {FB_UserData, FB_UserDataSub_CreditCard} from "../../../functions/src/shareCode/Share_S_Classes";
import TqDropdown from "@/components/basic/TqDropdown";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";
import TqImage from "@/components/basic/TqImage";
import TqCreditCard from "@/components/unpure/TqCreditCard";
import { eventListener_addEventListenerToObj, eventListener_removeEventListenerToObj } from '@/scripts/S_EventListeners';

export default {
    name: "TqCreditCardsList",
    components: {TqCreditCard, TqImage, TqLoaderButton, TqDropdown, TqLoaderContainer, TqPopup},
    props:{
        p_uds_creditCards_byId_c:{
            type : Object,
            require: true
        },
        pe_clickCreditCard_f:{
            type: Function,
        },
        p_currentUserData_c:{
            type:FB_UserData,
            require: true
        },
        p_showDropDown_b:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{

            showPopup_vb : {val : false},
            selected_c : undefined,
            approveJ5_b : false,
            icreditUrl_s : undefined,

            //store
            store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

            // imports
            ass_strings :  ass_strings,


        }
    },
    computed:{
        co_mainCreditCard_c(){
            return FB_UserDataSub_CreditCard.udscc_ms_getMainCreditCard_c(this.p_uds_creditCards_byId_c)
        },
    },
    methods:{
        m_clickCreditCard_f(creditCard_c){
            if(this.pe_clickCreditCard_f){
                this.pe_clickCreditCard_f(creditCard_c)
            }

        },
        m_addCreditCard_f(){
            this.showPopup_vb.val = true
            this.approveJ5_b = false
            this.icreditUrl_s = null
            server_getPaymentLandingPage_token_f({
                c_currency_e        : enum_costCurrency_n.DOLLAR,
                langCode_e          : this.store_system_langCode_ve.val,
                currentUserData_c   : this.p_currentUserData_c,
                cb_f : (ans_o) =>{
                    this.icreditUrl_s = ans_o.URL
                }
            })
        },
        m_removeCreditCard_f(udscc_id_s){
            this.$delete(this.p_uds_creditCards_byId_c, udscc_id_s)
        }
    },
    created(){
        eventListener_addEventListenerToObj(window, enum_eventsListenersNames.message, false, this.$options.name, (event) => {
            const msg_s = event.data.msg
            if(msg_s === enum_iframeMsg.success_s){
                this.showPopup_vb.val = false
            }
        })
    },
    destroyed(){
        eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.message, this.$options.name)
    }
}
</script>

<style scoped>

</style>